<template>
  <div class="contest-user__info">
    <div class="contest-user__name ellipsis">
      <span class="ellipsis">{{ user.nickname }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("contest", ["user"])
  }
};
</script>

<style lang="scss">
.contest-user {
  &__info,
  &__name {
    display: inline-flex;
    align-items: center;
  }

  &__info {
    justify-content: flex-start;
    max-width: 220px;
    height: 50px;
    padding-left: 6px;

    @include breakpoint("md-only") {
      max-width: 135px;
    }
  }
}

.contest-user__info {
  .menubar & {
    flex: 1 1 100% !important;
  }
}
</style>
